import * as modal from "../util/modal.ts";
import * as amplify from "../util/amplify.ts";
import { FilerTreeCache } from "../server/objects/FilerBeans.ts"
import { newMultiBar } from "../util/progressbarmulti.ts"
import { registerFileDropConsumer, registerDragStart } from "../lib/FileUtils.ts";
import { getDomMetaId } from "../util/Html.ts";
import { sameSet } from "../lib/ArrayUtil.ts";
import * as i18n from "../i18n.ts";
import * as FwDatas from "../FwDatas.ts";
import MultiplexApi,{setUploadProgressBar} from "../server/MultiplexApi.ts"
import { FolderInputBean, IFilerInputBean } from "../server/fizapilib.auto.ts";



registerDragStart(".filer-file",async function(ev,dropPromiseBuilder){
  var
    movingFile = FilerTreeCache.get(getDomMetaId(this)),
    potentialDrop = Array.from(document.querySelectorAll<HTMLElement>('.filer-folder'))
      .filter(node=>node.getAttribute('data-fw-meta-id')!==movingFile.parentFolderId),
    dropEvent = await dropPromiseBuilder(this,potentialDrop);

  movingFile.parentFolderId = getDomMetaId(dropEvent.target as HTMLElement)
  amplify.publishAsync('filerNeedRefresh');
  await MultiplexApi.filerputfile(movingFile)
  modal.toastDone('files.toastfilemoved',movingFile)
  
});

registerDragStart(".pane-main .filer-folder",async function(ev,dropPromiseBuilder){
  var
    folder = FilerTreeCache.get(getDomMetaId(this)),
    potentialDrop = Array.from(document.querySelectorAll<HTMLElement>('.filer-folder'))
      .filter(node=>node.getAttribute('data-fw-meta-id')!==folder.parentFolderId),
    dropEvent = await dropPromiseBuilder(this,potentialDrop),
    targetFolder = FilerTreeCache.get(getDomMetaId(dropEvent.target as HTMLElement))
    if(targetFolder===folder){
      modal.oops(i18n.get('files.errors.move_folder_into_itself',folder.name))
      return;
    }

    if(targetFolder.getPath().indexOf(folder)>-1){
      modal.oops(i18n.get('files.errors.move_folder_into_subfolder',folder.name))
      return;
    }
    let creator = FwDatas.getProfile();
    if(targetFolder.parentFolderId!==undefined){
      if(creator.accountId!==folder.accountId && !sameSet(folder.sharedMembers(),targetFolder.sharedMembers())) {
        modal.oops(i18n.get('files.errors.move_folder_different_sharing',{folderName:folder.name,creatorName:creator.firstName}))
        return;
      }

    }
    if(targetFolder && targetFolder!==folder){
      amplify.publishAsync('filerNeedRefresh');
      var updatedFolder = await MultiplexApi.filerputfolder(new FolderInputBean({
        metaId:folder.metaId,
        parentFolderId:targetFolder.metaId
      }))
      modal.toastDone('files.toastfoldermoved',updatedFolder)
    }
});


registerFileDropConsumer(async function factory(){
  return {
    nodes:Array.from(document.querySelectorAll('.filer-folder')),
    ondrop(event){
      var metaId = getDomMetaId(event.target as HTMLElement);
      if(metaId){
        upload(metaId,Array.from(event.dataTransfer.files))
      }
    }
  }
})

export async function upload(parentFolderId :string,files : File[]){
  if(files.length===0) return;
  if(files.length>50){
    await modal.alert({
      title:"files.warnupload.title",
      message:"files.warnupload.message",
    })
    files.length = 50
  }
  try{
    var ProgressBar = newMultiBar(files.length);
    for(var i=0;i<files.length;i++){
      setUploadProgressBar(ProgressBar.subProgress())
      await MultiplexApi.filerputfile(new IFilerInputBean({parentFolderId}),files[i])
    }
  } catch(err){
    if(err.code==='611'){
      modal.oops('fw2.apierrors.611file')
    }
    console.log(err)
    //FIXME sous le tapis parceque c'est "normal" que ca plante, le serveur renvoi du gzip sans le dire pour une video
    //modal.oops('fw2.defaultError')
  } finally{
    ProgressBar.close()
    amplify.publish('filerNeedRefresh')
    if(i>0){
      modal.toastDone('files.toastfileuploaded',i)
    }
  }

}
